import React from 'react';
import { useParams, Link } from 'react-router-dom';
import './Blog.css';

// DATA ARTIKEL (Pastikan ada di dalam file ini agar tidak error "not defined")
const blogArticles = [
    {
        id: 1,
        title: "Future of AI: Integrating Gemini in Web Apps",
        content: `Kecerdasan buatan bukan lagi masa depan, melainkan masa kini. Integrasi Gemini AI ke dalam aplikasi web memungkinkan pengembang untuk menciptakan fitur cerdas seperti chatbot yang memahami konteks, ringkasan konten otomatis, hingga analisis data real-time.`,
        date: "15 Maret 2026",
        author: "Rony Saputra",
        category: "AI & Tech",
        image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=500"
    },
    {
        id: 2,
        title: "Modern UI/UX Trends for Developer Hubs",
        content: `Desain untuk developer membutuhkan keseimbangan antara estetika dan fungsionalitas. Glassmorphism memberikan kesan modern dan transparan, sementara Dark Mode mengurangi kelelahan mata saat coding dalam waktu lama.`,
        date: "10 Maret 2026",
        author: "Rony Saputra",
        category: "Design",
        image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?q=80&w=500"
    },
    {
        id: 3,
        title: "React JS: Building Nexus Community Hub",
        content: `Membangun Nexus Community Hub dimulai dengan struktur komponen yang modular. Dengan menggunakan React 18 dan library seperti Framer Motion, kita dapat membuat transisi antar halaman yang sangat mulus.`,
        date: "5 Maret 2026",
        author: "Rony Saputra",
        category: "Development",
        image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?q=80&w=500"
    },
    {
        id: 4,
        title: "Cybersecurity 2026: Melindungi Data Xyrons",
        content: `Keamanan adalah prioritas utama di Xyrons Hub. Kami mengimplementasikan sistem enkripsi berlapis untuk memastikan setiap sesi browsing melalui Secure Gateway tetap privat.`,
        date: "1 Maret 2026",
        author: "Admin Xyrons",
        category: "Security",
        image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=500"
    },
    {
        id: 5,
        title: "Evolusi GPU untuk AI Rendering",
        content: `Menjalankan model AI secara lokal membutuhkan hardware yang mumpuni. Kita akan membahas optimalisasi VRAM pada kartu grafis terbaru untuk mempercepat proses pembuatan gambar.`,
        date: "28 Feb 2026",
        author: "Rony Saputra",
        category: "Hardware",
        image: "https://images.unsplash.com/photo-1587202377425-991ae3a3e47a?q=80&w=500"
    },
    {
        id: 6,
        title: "Masa Depan Arsitektur Digital",
        content: `Dengan tools seperti Planner 5D dan Midjourney, proses rendering yang dulu memakan waktu berhari-hari kini selesai dalam hitungan detik.`,
        date: "25 Feb 2026",
        author: "Admin Xyrons",
        category: "Architecture",
        image: "https://images.unsplash.com/photo-1600585154340-be6199f7f009?q=80&w=500"
    },
    {
        id: 7,
        title: "Prompt Engineering: Skill Wajib 2026",
        content: `Bukan hanya bertanya, tapi mengarahkan. Prompt engineering adalah seni memberikan instruksi yang presisi kepada AI untuk hasil maksimal.`,
        date: "22 Feb 2026",
        author: "Xyrons Bot",
        category: "Education",
        image: "https://images.unsplash.com/photo-1675271591211-126ad94e495d?q=80&w=500"
    },
    {
        id: 8,
        title: "Visi Komunitas Xyrons Hub",
        content: `Membangun ekosistem di mana setiap developer bisa berkontribusi. Xyrons Hub bertujuan menjadi jembatan antara ide kreatif dan eksekusi teknis.`,
        date: "20 Feb 2026",
        author: "Rony Saputra",
        category: "Community",
        image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=500"
    },
    {
        id: 9,
        title: "Integrasi Smart Home dengan AI",
        content: `Teknologi otomasi rumah kini semakin pintar dengan integrasi API AI. Bayangkan rumah yang tahu kapan Anda butuh kopi atau penyesuaian suhu otomatis.`,
        date: "15 Feb 2026",
        author: "Tech Insider",
        category: "Smart Tech",
        image: "https://images.unsplash.com/photo-1558002038-103792e1798e?q=80&w=500"
    },
    {
        id: 10,
        title: "Tips Cloud Hosting untuk Project React",
        content: `Memilih platform deployment yang tepat sangat krusial. Kita akan membandingkan performa server di wilayah Asia Tenggara untuk project berbasis React.`,
        date: "10 Feb 2026",
        author: "Admin Xyrons",
        category: "Web Dev",
        image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=500"
    }
];

export default function BlogDetail() {
    const { id } = useParams();
    // Mencari artikel berdasarkan id dari URL
    const post = blogArticles.find(item => item.id === parseInt(id));

    if (!post) {
        return (
            <div style={{ color: '#fff', textAlign: 'center', padding: '100px' }}>
                <h2>Artikel tidak ditemukan!</h2>
                <Link to="/blog" style={{ color: '#00d2ff' }}>Kembali ke Blog</Link>
            </div>
        );
    }

    return (
        <div style={{ backgroundColor: '#000', minHeight: '100vh', color: '#fff', padding: '80px 20px' }}>
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                <Link to="/blog" style={{ color: '#666', textDecoration: 'none', fontSize: '14px' }}>← Kembali ke Blog</Link>

                <header style={{ marginTop: '30px' }}>
                    <span style={{ color: '#00d2ff', fontWeight: 'bold', fontSize: '12px' }}>{post.category}</span>
                    <h1 style={{ fontSize: '2.5rem', margin: '15px 0', lineHeight: '1.2' }}>{post.title}</h1>
                    <p style={{ color: '#888' }}>{post.date} • Ditulis oleh <strong>{post.author}</strong></p>
                </header>

                <img src={post.image} alt={post.title} style={{ width: '100%', borderRadius: '20px', margin: '30px 0' }} />

                <article style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#ccc' }}>
                    {post.content.split('\n').map((paragraph, index) => (
                        <p key={index} style={{ marginBottom: '20px' }}>{paragraph}</p>
                    ))}
                </article>
            </div>
        </div>
    );
}